import { LanguageCode } from '@hazadapt-git/public-core-base'

export interface InfoUsageDisclaimerTextConfig {
    title: string
    body: string
    linkText: string
}

export const infoUsageDisclaimerText: Map<
    LanguageCode,
    InfoUsageDisclaimerTextConfig
> = new Map<LanguageCode, InfoUsageDisclaimerTextConfig>([
    [
        LanguageCode.ENGLISH,
        {
            title: `How is my information used?`,
            body: `We ask you for this information in order to connect you to local disaster preparation resources. We never sell or share personally identifiable information with anyone.`,
            linkText: 'Learn more about how HazAdapt protects your data.',
        },
    ],
    [
        LanguageCode.SPANISH,
        {
            title: `¿Cómo se utiliza mi información?`,
            body: `Te pedimos esta información para conectarte con recursos locales de preparación ante desastres. Nunca vendemos ni compartimos información personal identificable con nadie.`,
            linkText: 'Descubre cómo HazAdapt protege tus datos.',
        },
    ],
    [
        LanguageCode.GERMAN,
        {
            title: `Wie werden meine Informationen verwendet?`,
            body: `Wir bitten Sie um diese Informationen, um Sie mit lokalen Ressourcen zur Katastrophenvorsorge in Verbindung zu bringen. Wir verkaufen oder teilen niemals personenbezogene Informationen mit irgendjemandem.`,
            linkText:
                'Erfahren Sie mehr darüber, wie HazAdapt Ihre Daten schützt.',
        },
    ],
    [
        LanguageCode.FRENCH,
        {
            title: `Comment mes informations sont-elles utilisées ?`,
            body: `Nous vous demandons ces informations afin de vous mettre en relation avec des ressources locales de préparation aux catastrophes. Nous ne vendons ni ne partageons jamais d’informations personnelles identifiables avec qui que ce soit.`,
            linkText: 'Découvrez comment HazAdapt protège vos données.',
        },
    ],
    [
        LanguageCode.MANDARIN,
        {
            title: `我的信息是如何被使用的？`,
            body: `我们请求您获取这些信息，以便将您与当地的灾害准备资源连接起来。我们绝不向任何人出售或分享个人身份信息。`,
            linkText: '了解更多关于HazAdapt如何保护您的数据的信息。',
        },
    ],
    [
        LanguageCode.RUSSIAN,
        {
            title: `Как используется моя информация?`,
            body: `Мы просим вас предоставить эту информацию, чтобы связать вас с местными ресурсами по подготовке к стихийным бедствиям. Мы никогда не продаём и не делимся личной информацией с кем-либо.`,
            linkText:
                'Узнайте больше о том, как HazAdapt защищает ваши данные.',
        },
    ],
    [
        LanguageCode.JAPANESE,
        {
            title: `私の情報はどのように使われますか?`,
            body: `この情報は、地域の災害準備リソースとつながるためにお願いしています。私たちは個人を特定できる情報を誰にも販売または共有しません。`,
            linkText:
                'HazAdaptがどのようにデータを保護しているかについて詳しく学びましょう。',
        },
    ],
])
